import { reconcileOutputMonitor } from './output_monitor';

export function applyControllerApiVersion(controller, version) {
  if (!controller || String(version ?? '').trim() === '') return;
  controller.api_version = version;
  // Keep the aliases used by feature guards in sync without inventing a system
  // settings category before the first full snapshot has arrived.
  for (const system of [controller.settings?.system, controller.system]) {
    if (system && 'api_version' in system) system.api_version = version;
  }
  // A version push/HTTP refresh may precede the next telemetry response.
  if (controller.output_monitor) reconcileOutputMonitor(controller, {});
}
